import type {DataMarqueeEventData, DataMarqueeProps, DataMarqueeStatData} from '../../generic/DataMarquee/DataMarquee'

export const buildDataMarqueeItems = (
  events: DataMarqueeEventData[],
  stats: DataMarqueeStatData[],
): DataMarqueeProps['items'] => {
  const items: DataMarqueeProps['items'] = []
  let statIndex = 0

  // Insert the first stat after one event, then another after every four events.
  for (const [eventIndex, event] of events.entries()) {
    items.push({...event, type: 'event'})

    if (eventIndex % 4 === 0 && stats.length > 0) {
      // Cycle through the stats when there are more insertion points than stats.
      const stat = stats[statIndex % stats.length]
      if (stat) {
        items.push({...stat, type: 'stat'})
        statIndex += 1
      }
    }
  }

  return items
}
